import {createAction, props} from "@ngrx/store";
import {IMenuGroup} from "../models/menu-group";


export const loadMenuGroups = createAction('[MenuGroup] Load Menu Group Items');
export const loadMenuGroupsSuccess = createAction('[MenuGroup] Load Menu Groups Success', props<{
  menuGroups: IMenuGroup[]
}>());
export const loadMenuGroupsFailure = createAction('[MenuGroup] Load Menu Groups Failure', props<{ error: string }>());
export const addMenuGroup = createAction('[MenuGroup] Add MenuGroup', props<{ menuGroup: IMenuGroup }>());
export const updateMenuGroup = createAction('[MenuGroup] Update MenuGroup', props<{ menuGroup: IMenuGroup }>());
export const deleteMenuGroup = createAction('[MenuGroup] Delete MenuGroup', props<{ id: string }>());
